/**
 * 通用正则表达式
 */
const regex = {
  /**
   * 邮箱
   */
  email: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
  /**
   * 手机号
   */
  phone: /^1[3456789][0-9]{9}$/,

  /**
   * 座机+手机号
   */
  contactPhone: /^1[3-9]\d{9}$|^0\d{2,3}-\d{7,8}$/,

  /**
   * 身份证号
   */
  idCard:
    /^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/,

  /**
   * 数字
   */
  number: /^-?\d*(\.\d*)?$/,
  /**
   * 整数
   */
  integer: /^(-?[1-9]\d*|0)$/,
  /**
   * 正整数
   */
  posInteger: /^([1-9]\d*|0)$/,
  /**
   * 负整数
   */
  negInteger: /^(-[1-9]\d*)$/,
  /**
   * 驾驶证
   */
  drivingLicensed:
    /^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/,
  /**
   * 护照
   */
  passport:
    /(^[EeKkGgDdSsPpHh]\d{8}$)|(^(([Ee][a-fA-F])|([DdSsPp][Ee])|([Kk][Jj])|([Mm][Aa])|(1[45]))\d{7}$)/,
  /**
   * 士兵证
   */
  soldierId: /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/,
  /**
   * 统一社会信用代码
   */
  uscc: /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/,

  /**
   * 数字或字母
   */
  numbersOrLetters: /^[A-Za-z0-9]*$/,

  /**
   * 英文名称
   */
  englishName: /^[A-Za-z0-9 .]*$/,

  /**
   * 两位小数的数
   */
  twoDecimalPlaces: /^\d+(\.\d{1,2})?$/,

  /**
   * 两位小数的正数
   */
  twoDecimalPosPlaces: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,

  /** 不含中文和空格 */
  notCnAndBlank: /^(?!.*[\u4e00-\u9fa5\s]).*$/,

  /** 学期格式 */
  semester: /^\d{4}-\d{4}-[1-9]$/,

  /**
   * url地址
   */
  // url: /^((https?|ftp|file):\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
  // eslint-disable-next-line no-useless-escape
  url: /^((https?|ftp|file):\/\/)?(([\w-]+\.)+[\w-]+|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))(:[0-9]{1,5})?(\/[\w-.\/?%&=]*)?$/,

  httpDomain: /^(https?:\/\/)?([\w-]+\.)+[\w-]+$/,
};

/**
 * 浮点数正则表达式
 * @param {number} minDigit 最少小数位数
 * @param {number} maxDigit 最多小数位数
 * @param {string} type 浮点数类型（positive正数，negative负数，否则不限正负）
 * @returns {RegExp}
 */
const floatRegexp = (minDigit, maxDigit, type) => {
  if (
    (!regex.posInteger.test(minDigit) && minDigit !== 0) ||
    (!regex.posInteger.test(maxDigit) && maxDigit !== 0)
  ) {
    throw new Error('minDigit and maxDigit must be an positive integer or 0');
  }
  if (minDigit > maxDigit) {
    throw new Error('minDigit must be smaller than or equal to maxDigit');
  }

  // 正负符号
  // eslint-disable-next-line no-nested-ternary
  const symbol = type === 'negative' ? '-' : type === 'positive' ? '' : '-?';
  // 是否一定有小数
  const hasDigit = minDigit === 0 ? '?' : '';

  const regexp = `^${symbol}([1-9]\\d*|0)(\\.\\d{${minDigit},${maxDigit}})${hasDigit}$`;
  return new RegExp(regexp);
};

/**
 * 密码正则验证（旧实现，写死 8~20 位 + 字母 + 数字 + 特殊字符）
 * 注：保留此函数避免影响其它旧调用方；新的修改密码页请使用 buildPwdRule / validatePwdByRule
 */
const passwordRegexp = () => {
  // 需要从配置读取
  // 密码在8位到20位之间，且同时包含特殊字符+字母+数字三种
  return /^(?=.*[a-z_])(?=.*\d)(?=.*[^a-z0-9_])[\S]{8,20}$/i;
};

/**
 * 密码最大长度（与历史 UI 提示一致）
 */
const PWD_MAX_LENGTH = 32;

/**
 * 默认最小密码长度：当安全配置中未启用长度限制或配置缺失时使用
 */
const DEFAULT_PWD_MIN_LENGTH = 8;

/**
 * 复杂度枚举（与后端 PassportEnum.PasswordComplexity 保持一致）：
 * 1=大写字母 2=小写字母 3=数字 4=特殊符号
 */
const PWD_COMPLEXITY = {
  UPPER: 1,
  LOWER: 2,
  NUMBER: 3,
  SPECIAL: 4,
};

/**
 * 复杂度项的可读名称（用于动态拼接密码规则提示文案）
 */
const PWD_COMPLEXITY_LABEL = {
  [PWD_COMPLEXITY.UPPER]: '大写字母',
  [PWD_COMPLEXITY.LOWER]: '小写字母',
  [PWD_COMPLEXITY.NUMBER]: '数字',
  [PWD_COMPLEXITY.SPECIAL]: '特殊符号',
};

/**
 * 「特殊符号」的判定正则：除大写字母、小写字母、数字以外的任何字符均视为特殊符号
 * 即不限制具体字符集，!@#$%^&*()_+-= 空格 中文标点 等都算
 */
const PWD_SPECIAL_CHAR_REGEXP = /[^A-Za-z0-9]/;

/**
 * 依据安全配置构造密码校验规则
 * @param {Object} options
 * @param {boolean} options.isEnablePwdLength  是否启用密码长度限制
 * @param {number}  options.pwdLength          最小长度（isEnablePwdLength 为 true 时生效）
 * @param {number[]|string[]} options.pwdComplexities 复杂度枚举值列表（1/2/3/4）
 * @returns {{
 *   minLength: number,
 *   maxLength: number,
 *   complexities: number[],
 *   desc: string,
 * }}
 */
const buildPwdRule = ({ isEnablePwdLength, pwdLength, pwdComplexities } = {}) => {
  // 解析最小长度：未启用或配置非法时回落到默认 8 位
  const lengthEnabled =
    isEnablePwdLength === true &&
    Number.isFinite(Number(pwdLength)) &&
    Number(pwdLength) > 0;
  const minLength = lengthEnabled
    ? Number(pwdLength)
    : DEFAULT_PWD_MIN_LENGTH;

  // 解析复杂度数组：兼容数字与字符串形式，去重并过滤未知值
  const complexities = Array.isArray(pwdComplexities)
    ? [...new Set(pwdComplexities.map((v) => Number(v)))].filter((v) =>
        [
          PWD_COMPLEXITY.UPPER,
          PWD_COMPLEXITY.LOWER,
          PWD_COMPLEXITY.NUMBER,
          PWD_COMPLEXITY.SPECIAL,
        ].includes(v),
      )
    : [];

  // 拼接用户可读的规则文案
  const parts = [`密码长度至少 ${minLength} 位`];
  if (complexities.length) {
    const labels = complexities.map((v) => PWD_COMPLEXITY_LABEL[v]);
    parts.push(`，且必须包含：${labels.join('、')}`);
  }
  const desc = parts.join('');

  return {
    minLength,
    maxLength: PWD_MAX_LENGTH,
    complexities,
    desc,
  };
};

/**
 * 按规则校验密码
 * @param {string} pwd 明文密码
 * @param {ReturnType<buildPwdRule>} rule 由 buildPwdRule 构造的规则
 * @returns {{ valid: boolean, message: string }}
 *
 * 注：本函数仅在前端做用户体验性校验，后端不再做规则校验；最终是否合法以此函数为准。
 */
const validatePwdByRule = (pwd, rule) => {
  if (!pwd) {
    return { valid: false, message: '密码不能为空' };
  }
  if (pwd.length < rule.minLength) {
    return { valid: false, message: `密码长度至少 ${rule.minLength} 位` };
  }
  if (pwd.length > rule.maxLength) {
    return { valid: false, message: `密码长度不能超过 ${rule.maxLength} 位` };
  }
  for (const c of rule.complexities) {
    if (c === PWD_COMPLEXITY.UPPER && !/[A-Z]/.test(pwd)) {
      return { valid: false, message: '密码必须包含大写字母' };
    }
    if (c === PWD_COMPLEXITY.LOWER && !/[a-z]/.test(pwd)) {
      return { valid: false, message: '密码必须包含小写字母' };
    }
    if (c === PWD_COMPLEXITY.NUMBER && !/[0-9]/.test(pwd)) {
      return { valid: false, message: '密码必须包含数字' };
    }
    // 特殊符号 = 任何非字母数字字符
    if (c === PWD_COMPLEXITY.SPECIAL && !PWD_SPECIAL_CHAR_REGEXP.test(pwd)) {
      return { valid: false, message: '密码必须包含特殊符号' };
    }
  }
  return { valid: true, message: '' };
};

export default regex;
export {
  floatRegexp,
  passwordRegexp,
  buildPwdRule,
  validatePwdByRule,
};
